/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Idea: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.0019 4C8.07178 4 5.62401 8.51535 7.83624 11.971L9.13517 14L14.8688 14L16.1677 11.9708C18.3797 8.51512 15.9319 4 12.0019 4ZM6.15183 13.0493C3.1355 8.33761 6.40271 2 12.0019 2C17.6009 2 20.8682 8.3373 17.8522 13.049L16.4404 15.2546C16.1468 15.7132 15.6394 16 15.084 16L8.91995 16C8.36459 16 7.8572 15.7132 7.56365 15.2546L8.40585 14.7155L7.56365 15.2546L6.15183 13.0493ZM9.00187 17H12.0019H15.0019C15.5542 17 16.0019 17.4477 16.0019 18C16.0019 18.5523 15.5542 19 15.0019 19H12.0019H9.00187C8.44959 19 8.00187 18.5523 8.00187 18C8.00187 17.4477 8.44959 17 9.00187 17ZM10.0019 20C9.44959 20 9.00187 20.4477 9.00187 21C9.00187 21.5523 9.44959 22 10.0019 22H12.0019H14.0019C14.5542 22 15.0019 21.5523 15.0019 21C15.0019 20.4477 14.5542 20 14.0019 20H12.0019H10.0019Z'
      fill='currentColor'
    />
  </React.Fragment>
)
